<template>
  <div>
    <b-card class="mb-5">
      <b-row>
        <b-col sm="3">
          <b-form-group label="Situacao">
            <input-select
              v-model="model.situacao"
              placeholder="Todos"
              :options="$api.Arrays.SituacaoCadastroRestritivo"
              single
            />
          </b-form-group>
        </b-col>

        <!-- data inicial -->
        <b-col sm="3">
          <b-form-group label="Data Inicial">
            <kendo-datepicker
              v-model="model.dataInicial"
              :max="dtMax"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
            ></kendo-datepicker>
          </b-form-group>
        </b-col>

        <!-- data final -->
        <b-col sm="3">
          <b-form-group label="Data Final">
            <kendo-datepicker
              v-model="model.dataFinal"
              :min="dtMin"
              :max="dtMax"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
            ></kendo-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object },
  },
  data() {
    return {};
  },
  computed: {
    dtMin: function () {
      return this.model.datainicial
        ? kendo.parseDate(this.model.datainicial)
        : new Date("1970-01-01");
    },
    dtMax: function () {
      return this.model.datafinal
        ? kendo.parseDate(this.model.datafinal)
        : new Date();
    },
    model: {
      get() {
        var obj = this.value;
        return obj;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
